export default "__VITE_ASSET__Dy7ms_oo__"